import { useState } from "react";
import ConfirmDialog from "@/components/common/ConfirmDialog";

export interface ArtistConfirmRequest {
  title: string;
  message: string;
  /** Rendered as a list under the message (replaces the old "\n"-joined window.confirm text). */
  lines?: string[];
  confirmText?: string;
  danger?: boolean;
  onConfirm: () => void;
}

/** O5: one-shot confirmations in the artist panels — `confirm({...})` opens a ConfirmDialog; render `dialog` once. */
export function useArtistConfirm() {
  const [request, setRequest] = useState<ArtistConfirmRequest | null>(null);
  const dialog = (
    <ConfirmDialog
      isOpen={request !== null}
      title={request?.title ?? ""}
      message={request?.message ?? ""}
      extra={
        request?.lines?.length ? (
          <ul className="mt-2 space-y-1 text-sm">
            {request.lines.map((line, i) => (line ? <li key={i} className="break-words">{line}</li> : <li key={i} aria-hidden className="h-2" />))}
          </ul>
        ) : undefined
      }
      confirmText={request?.confirmText}
      variant={request?.danger ? "danger" : "default"}
      onConfirm={() => {
        const current = request;
        setRequest(null);
        current?.onConfirm();
      }}
      onCancel={() => setRequest(null)}
    />
  );
  return { confirm: setRequest, dialog };
}
